export const emptyValueToHyphen = (value: number | string | undefined | null): string => (
  value ? String(value) : '-');
